// namespaces
export const MEMBER_WANNABE_NAMESPACE = 'member_wannabe'
export const MEMBERSHIP_NAMESPACE = 'membership'

// keys
export const SIMULATOR_VERSION = 'simuleite_version'
export const ACCREDITED_NETWORK_AB_TEST = 'accredited_network_ab_test'
export const ACCREDITED_NETWORK_SURVEY_LIST = 'accredited_network_survey_list'
export const ACCREDITED_NETWORK_SURVEY_PROVIDERS =
  'accredited_network_survey_providers'

// Global flags
export const globalFeatureFlags = []
